exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.breadcrumbs span:first-child a{\n  font-weight: bold;\n  font-family: 'TTNorms Bold', sans-serif;\n}\n", ""]);

// exports
